<template>
  <div>
    <div class="clearfix">
      <div class="page-title float-left">수행평가 결과보기</div>
      <div class="float-right"><mdb-btn icon="undo" class="py-2" @click="onBack">돌아가기</mdb-btn></div>
    </div>
    <perform-test-view :test="test" :answer="answer" />
    <div class="text-right"><mdb-btn icon="undo" class="py-2" @click="onBack">돌아가기</mdb-btn></div>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import PerformTestAnswer from '@/models/test/PerformTestAnswer'
import PerformTestView from '@/components/test/perform/PerformTestView.vue';
export default {
  components: { PerformTestView },
  name: 'StudentPerformTestView',
  computed: {
  },
  data: () => ({
    test: {},
    answer: {}
  }),
  methods: {
    onBack () {
      this.$router.push({ name: 'StudentTestSummaryPage' })
    },
    async load () {
      const { test, answer } = this.$route.query
      const data = await this.$getPerformTestAndAnswer(test, answer)
      this.test = data.test
      this.answer = data.answer
    }
  },
  created () {
    this.load()
  },
  watch: {}
}
</script>
